const TOKEN_KEY = 'way2umrah.agent.accessToken';

export function getAgentToken() {
  if (typeof window === 'undefined') {
    return null;
  }

  return window.sessionStorage.getItem(TOKEN_KEY);
}

export function setAgentToken(token) {
  if (typeof window === 'undefined') {
    return;
  }

  window.sessionStorage.setItem(TOKEN_KEY, token);
  clearAgentProfileCache();
}

export function clearAgentToken() {
  if (typeof window === 'undefined') {
    return;
  }

  window.sessionStorage.removeItem(TOKEN_KEY);
  clearAgentProfileCache();
}

let profileCache = {
  token: null,
  profile: null,
  promise: null,
};

export function getAgentProfileCache(token) {
  if (!token || profileCache.token !== token) {
    return { profile: null, promise: null };
  }
  return { profile: profileCache.profile, promise: profileCache.promise };
}

export function setAgentProfileCache(token, profile, promise = null) {
  profileCache = { token, profile, promise };
}

export function clearAgentProfileCache() {
  profileCache = { token: null, profile: null, promise: null };
}
